'use client';

import { useEffect, useState } from 'react';

import { usePathname, useRouter } from 'next/navigation';

export const ClientTasks = () => {
  const router = useRouter();

  const pathname = usePathname();
  const [isScreenVisible, setIsScreenVisible] = useState(true);
  const [isScreenFocused, setIsScreenFocused] = useState(true);
  useEffect(() => {
    const onVisibility = () => setIsScreenVisible(document.visibilityState === 'visible');
    const onFocus = () => setIsScreenFocused(true);
    const onBlur = () => setIsScreenFocused(false);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    onVisibility();
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, []);
  const [canRevalidate, setCanRevalidate] = useState(false);

  useEffect(() => {
    if (!isScreenVisible || !isScreenFocused) setCanRevalidate(true);
    if (isScreenVisible && canRevalidate) router.refresh();
  }, [isScreenVisible, router]);

  useEffect(() => {
    setCanRevalidate(false);
  }, [pathname]);

  return null;
};
